export enum TYPE_PARAMETRE_RAPPORT_COURRIER {
  CHECKBOX_INPUT = "Case à cocher",
  DATE_INPUT = "Champ date",
  NUMBER_INPUT = "Champ nombre",
  SELECT_INPUT = "Liste déroulante",
  TEXT_INPUT = "Champ texte",
  POINT = "Point",
  POLYGON = "Polygone",
  LINESTRING = "Ligne",
}

export const userParamRapportCourrier = [
  "#ZONE_COMPETENCE_ID#",
  "#UTILISATEUR_ID#",
  "#ORGANISME_ID#",
];
